import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _querySizeTip(
  {
    page, size, direction, sort, appInfoId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-info-detail`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      appInfoId
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _querySizeTips(sizeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-info-detail/${sizeId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addSizeTip(
  {
    type,
    coverPath,
    appInfoId,
    typeEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-info-detail`,
    method: 'post',
    data: {
      type,
      coverPath,
      appInfoId,
      typeEn,
    },
  });
}

/**
 * 更新
 * @param appInfoId
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateSizeTip(sizeId, {
  type,
  coverPath,
  appInfoId,
  typeEn,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-info-detail/${sizeId}`,
    method: 'patch',
    data: {
      type,
      coverPath,
      appInfoId,
      typeEn,
    },
  });
}

/**
 * 删除
 * @param appInfoId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteSizeTip(sizeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/app-info-detail/${sizeId}`,
    method: 'delete',
  });
}

export default {};
